import { useLayoutEffect, useRef } from 'react';
import { css } from '@emotion/react';
/** The component that renders the container of the video wrapper under a div. */
export const VideoWrapperRenderer = ({ videoWrapper }) => {
    const ref = useRef(null);
    useLayoutEffect(() => {
        if (ref.current) {
            while (ref.current.firstChild) {
                ref.current.firstChild.remove();
            }
            ref.current.appendChild(videoWrapper.getContainer());
        }
    }, [videoWrapper]);
    return (<div css={css `
        width: 100%;
        height: 100%;
      `} ref={ref}/>);
};
